import React from 'react';
import projectUtils from '../../utils/project-utils.js';

function ExpiryDateCellRenderer({ value }) {
    if (!value) return (
        <div className="flex items-center h-full">
            <span className="text-xs text-gray-400">Sem expiração</span>
        </div>
    );
    const expired = new Date(value) < new Date();
    return (
        <div className="flex flex-col justify-center h-full gap-0.5">
            <span className="text-sm">{projectUtils.formatDate(value)}</span>
            {expired && <span className="text-xs font-medium text-red-500">Expirado</span>}
        </div>
    );
}

export default ExpiryDateCellRenderer;
